// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".params-item[data-v-22b5a658] {\n  padding-bottom: 0 !important;\n}\n.params-item > div[data-v-22b5a658] {\n    width: 230px;\n    margin-right: 16px;\n    margin-bottom: 16px;\n}\n[data-v-22b5a658] .el-table thead th.el-table__cell {\n  background-color: #f4f6f9;\n}\n.textAline[data-v-22b5a658] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
